import React from 'react';  
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import constants from 'utils/constants'
import defaultProfile from 'images/character/default_profile_1-309x309.png'
export default function AddCommentReplyBtnBar({onClick, btnStyle}) {  
	const userInfo = useSelector((state) => {
		return state.userInfo
	})

	const profileImg = (userInfo?.profile_img)?`${constants.imagePath}/user_profile_img/${userInfo.profile_img}`:defaultProfile;
	//defaultProfile
	return (
		<BarSection onClick={()=>{if(onClick)onClick()}}> 
			<ProfileWrapper>
			<ProfileIcon src={profileImg}/>
			</ProfileWrapper>
			<CommentReplyBtn style={btnStyle}>
				답글을 달아주세요
			</CommentReplyBtn>
		</BarSection>
	);
}
export const BarSection = styled.div`
	display: flex;
`
export const ProfileWrapper = styled.div`
	display: inline-block;
	height : calc(100vw*(29/375)) ;
	width: calc(100vw*(29/375));
	min-height : calc(100vw*(29/375)) ;
	min-width: calc(100vw*(29/375));
	margin-right: calc(100vw*(6/375));
	border: 1px solid #C4C4C4;
	border-radius: 100%;
	background: #fff;
	overflow: hidden;
`
export const ProfileIcon = styled.img`
	width : 100%;
	height : 100%;
	object-fit: cover;
`

export const CommentReplyBtn = styled.div`
	width : 100%;
	padding : calc(100vw*(6/375)) calc(100vw*(14/375));
	background: #F7F7F7;
	border-radius: calc(100vw*(19/375));
 
	font-style: normal;
	font-weight: normal;
	font-size: calc(100vw*(11/375));
	color: #7F7F7F;
`